<template>
  <aside 
    :class="['sidebar', { 'sidebar-closed': isSidebarClosed, 'mobile-hidden': isMobile && !isSidebarOpen, 'mobile-horizontal': isMobile && isSidebarClosed }]"
    :style="{ transform: isSidebarClosed && isMobile ? 'translateX(-300px)' : 'translateX(0)' }"
  >
    <div class="sidebar-scrollable"> 
      <!-- Sidebar User Info -->
      <div class="sidebar-user-info" v-if="authUser?.user && vipLevel && vipLevel.requiredXp">
        <img :src="authUser.user.avatar" alt="Avatar" class="user-avatar" />
        <div class="user-info-text">
          <div class="username">
            {{ authUser.user.username }}
            <img v-if="vipBadgeImage" :src="vipBadgeImage" class="vip-badge-on-avatar" alt="VIP"/>
          </div>
          <div class="balance-box">
            <img :src="activeWalletIcon" class="wallet-icon" alt="wallet" />
            <AmountNumber :amount="activeWallet.balance" :symbol="getCurrencySymbol(selectedFiat)" />
          </div>
          <div class="vip-progress">
            <div class="vip-progress-bar">
              <div class="vip-progress-fill" :style="{ width: vipProgress + '%' }"></div>
            </div>
            <div class="vip-progress-text">
  {{ vipProgress }}%  
</div>
          </div>
        </div>
      </div>

      <!-- Coin Card -->
      <div class="coin-card">
        <div class="button-grid">
          <div class="grid-item" @click="navigateTo('/vip')">
            <img src="@/assets/img/sidebar/1.png" alt="VIP" />
            <span>{{ $t('sidebar.bonusvip') }}</span>
          </div>
          <div class="grid-item" @click="openSpinModal">
  <img src="@/assets/img/sidebar/2.png" alt="Wheel" />
  <span>{{ $t('sidebar.spinwheel') }}</span>
</div>
          <div class="grid-item" @click="navigateTo('/category/slots')">
            <img src="@/assets/img/sidebar/3.png" alt="Slot" />
            <span>{{ $t('sidebar.slots') }}</span>
          </div>
          
    <div class="grid-item" @click="openDailyBonus">
      <img src="@/assets/img/sidebar/4.png" alt="Daily Bonus" />
      <span>{{ $t('sidebar.dailybonus') }}</span>
    </div>
        </div>
        <div class="coin-center">
          <img src="@/assets/img/sidebar/coin.png" alt="Coin" />
        </div>
    
   
      </div>

      <ModalJackpot v-if="showModal" :showModal="showModal" @close="closeModal" />

      <!-- Sidebar Ana Butonlar -->
      <ul class="sidebar-buttons">
        <li v-for="(category, index) in categories" :key="index">
          <div
            :class="['button-item', { open: activeCategory === category.name }]"
            @click="toggleCategory(category.name)"
            @mouseenter="showSidebarTooltip(category.name, $event)"
            @mouseleave="hideSidebarTooltip"
          >
            <img :src="category.icon" :alt="category.name" class="button-icon" />
            <span class="button-text">{{ category.name }}</span>
            <span class="dropdown-icon" :class="{ 'open': activeCategory === category.name }">
              

<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24">
  <defs>
    <linearGradient id="gold-gradient" gradientTransform="rotate(420)">
      <stop offset="0%" stop-color="rgb(255, 206, 0)" />
      <stop offset="49%" stop-color="rgb(255, 206, 0)" />
      <stop offset="49%" stop-color="rgb(255, 184, 0)" />
      <stop offset="100%" stop-color="rgb(255, 184, 0)" />
    </linearGradient>
  </defs>

  <!-- ALT ARKA PLAN (gradient eklendi) -->
  <path fill="url(#gold-gradient)" d="M3.464 20.536C2 19.07 2 16.714 2 12s0-7.071 1.464-8.536C4.93 2 7.286 2 12 2s7.071 0 8.535 1.464C22 4.93 22 7.286 22 12s0 7.071-1.465 8.535C19.072 22 16.714 22 12 22s-7.071 0-8.536-1.465" opacity="1"/>

  <!-- OKLAR -->
  <path fill="#fff" d="M14.47 11.97a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06L12 14.44z"/>
  <path fill="#fff" d="M14.47 7.97a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06L12 10.44z"/>
</svg>

            </span>
          </div>

          <!-- Alt Kategoriler -->
          <transition name="slide-fade">
            <ul v-if="activeCategory === category.name" class="sub-menu">
            <li 
  v-for="(subItem, subIndex) in category.subCategories" 
  :key="subIndex" 
  class="sub-item" 
  @click.stop="navigateTo(subItem.link)"
  @mouseenter="showSidebarTooltip(subItem.name, $event)"
  @mouseleave="hideSidebarTooltip"
>

                <img :src="subItem.icon" :alt="subItem.name" class="sub-item-icon" />
                <span class="sub-item-text">{{ subItem.name }}</span>
              </li>
            </ul>
          </transition>
        </li>
      </ul>

      <!-- Extra Buttons -->
      <div class="extra-buttons">
        <div 
          v-for="(button, index) in extraButtons" 
          :key="index" 
          class="button-item" 
          @click="navigateTo(button.link)"
          @mouseenter="showSidebarTooltip(button.name, $event)"
          @mouseleave="hideSidebarTooltip"
        >
          <img :src="button.icon" :alt="button.name" class="button-icon" />
          <span class="button-text">{{ button.name }}</span>
        </div>
      </div>

      <!-- Last Buttons -->
      <div class="extra-buttons">
        <div 
          v-for="(button, index) in lastButtons" 
          :key="index" 
          class="button-item" 
          @click="navigateTo(button.link)"
          @mouseenter="showSidebarTooltip(button.name, $event)"
          @mouseleave="hideSidebarTooltip"
        >
          <img :src="button.icon" :alt="button.name" class="button-icon" />
          <span class="button-text">{{ button.name }}</span>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="sidebar-footer">
      <div class="footer-buttons">
        <div class="footer-btn" @click="openLanguage" @mouseenter="showSidebarTooltip($t('sidebar.language'), $event)" @mouseleave="hideSidebarTooltip">
          <img src="@/assets/img/sidebar/lang.svg" alt="Language" />
          <span>{{ $t('sidebar.language') }}</span>
        </div>
        <div class="footer-btn" @click="openSupport" @mouseenter="showSidebarTooltip($t('sidebar.support'), $event)" @mouseleave="hideSidebarTooltip">
          <img src="@/assets/img/sidebar/support.svg" alt="Support" />
          <span>{{ $t('sidebar.support') }}</span>
        </div>
      </div>

      <div class="footer-banner">
        <div class="banner-text">
          <h4>{{ $t('sidebar.footertitle') }}</h4>
          <p>{{ $t('sidebar.footersubtitle') }}</p>
          <button class="download-btn">{{ $t('sidebar.download') }}</button>
        </div>
        <div class="banner-img">
          <img src="@/assets/img/app.png" alt="App" />
        </div>
      </div>
    </div>
  </aside>

  <!-- Tooltip Balonu -->
  <div 
    v-if="isSidebarClosed && tooltip.visible" 
    class="sidebar-tooltip" 
    :style="{ top: tooltip.top + 'px', left: tooltip.left + 'px' }"
  >
    {{ tooltip.text }}
  </div>

  <LanguageModal :show="showLanguageModal" @close="showLanguageModal = false"/>
  <DailyRewardsModal
    :isOpen="dailyModal"
    @close="dailyModal = false"
  />
  <Spin v-if="spinModal" :isOpen="spinModal" @close="spinModal = false" />

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ModalJackpot from '@/components/modals/ModalJackpot.vue';
import AmountNumber from '@/components/AmountNumber';
import LanguageModal from '@/components/modals/LanguageModal.vue';
import DailyRewardsModal from '@/components/daily/DailyRewardsModal.vue'
import Spin from '@/components/Spin.vue'


export default {
  data() {
    return {
      showModal: false, // Modal görünürlüğünü kontrol ederiz
      showTooltip: false,
      tooltipText: "",
      tooltip: {
      visible: false,
      text: '',
      top: 0,
      left: 0,
      
    },
     
      showLanguageModal: false,
      selectedFiat: null,
      tooltipPosition: { top: 0, left: 0 },
      activeCategory: '', // Hangi kategori açık ise onu takip ediyoruz
      isMobile: false, // Mobil cihaz olup olmadığını kontrol ederiz
      isSidebarOpen: false, // Sidebar'ın mobilde açık olup olmadığını kontrol ederiz
      activeMode: 'casino', // Casino / Sports Switch için
      isDarkMode: false, // Dark / Light Mode için
      activeCategory: '', // Açık olan kategoriyi takip eder
categories: [
  {
    name: this.$t('sidebar.casino'),
    icon: require('@/assets/img/sidebar/svg/1/casino1.svg'),
    subCategories: [
      { name: this.$t('sidebar.rivoOriginals'), icon: require('@/assets/img/sidebar/svg/rivo.svg'), link: '/' },
      { name: this.$t('sidebar.slots'), icon: require('@/assets/img/sidebar/svg/slot.svg'), link: '/category/slots' },
      { name: this.$t('sidebar.liveCasino'), icon: require('@/assets/img/sidebar/svg/live.svg'), link: '/category/gameshow' },
 
      { name: this.$t('sidebar.fishing'), icon: require('@/assets/img/sidebar/svg/fishing.svg'), link: '/category/fishing' },
 
      { name: this.$t('sidebar.crash'), icon: require('@/assets/img/sidebar/svg/crash.svg'), link: '/category/crashgame' },
       

    ]
  },
  {
    name: this.$t('sidebar.sports'),
    icon: require('@/assets/img/sidebar/svg/1/sport1.svg'),
    subCategories: [
 
      { name: this.$t('sidebar.soccer'), icon: require('@/assets/img/sidebar/svg/soccer.svg'), link: '/game/sports' },
      { name: this.$t('sidebar.tennis'), icon: require('@/assets/img/sidebar/svg/tenis.svg'), link: '/game/sports' },
      { name: this.$t('sidebar.basketball'), icon: require('@/assets/img/sidebar/svg/basketball.svg'), link: '/game/sports' },
      { name: this.$t('sidebar.cricket'), icon: require('@/assets/img/sidebar/svg/criket.svg'), link: '/game/sports' },
      { name: this.$t('sidebar.fifa'), icon: require('@/assets/img/sidebar/svg/fifa.svg'), link: '/game/sports' },
      { name: this.$t('sidebar.americanFootball'), icon: require('@/assets/img/sidebar/svg/americanf.svg'), link: '/game/sports' },
      { name: this.$t('sidebar.iceHockey'), icon: require('@/assets/img/sidebar/svg/hockey.svg'), link: '/game/sports' },
      { name: this.$t('sidebar.handball'), icon: require('@/assets/img/sidebar/svg/handball.svg'), link: '/game/sports' },
      { name: this.$t('sidebar.racing'), icon: require('@/assets/img/sidebar/svg/racing.svg'), link: '/game/sports' }
    ]
  },
  {
    name: this.$t('sidebar.cryptoTrading'),
    icon: require('@/assets/img/sidebar/svg/1/crypto.svg'),
    subCategories: [
      { name: this.$t('sidebar.highLowSpread'), icon: require('@/assets/img/sidebar/svg/highlow.svg'), link: '/turbo' },
     
      { name: this.$t('sidebar.futures'), icon: require('@/assets/img/sidebar/svg/futures.svg'), link: '/futures' },

    ]
  },
  
],
extraButtons: [
  { name: this.$t('sidebar.vipClub'), icon: require('@/assets/img/sidebar/svg/1/vip.svg'), link: '/vip' },
  { name: this.$t('sidebar.bonus'), icon: require('@/assets/img/sidebar/svg/1/bonus.svg'), link: '/rewards' },
  { name: this.$t('sidebar.affiliate'), icon: require('@/assets/img/sidebar/svg/1/team.svg'), link: '/affiliates' },
  { name: this.$t('sidebar.promotions'), icon: require('@/assets/img/sidebar/svg/1/promo.svg'), link: '/promotions' },
  { name: this.$t('sidebar.leaderBoard'), icon: require('@/assets/img/sidebar/svg/1/leader.svg'), link: '/leaderboard' }
],


      lastButtons: [
        
       
        
      ],
      dailyModal: false,
      spinModal: false,

      
    };
  },


  components: {
    ModalJackpot,
     AmountNumber,
     LanguageModal,
     DailyRewardsModal,
     Spin
  },
computed: {
  ...mapGetters(['authUser', 'isSidebarClosed']),
  
  // 🔹 Önce VIP getter’ları alıyoruz
  ...mapGetters('vip', [
    'vipLevel',
    'userXp',
    'vipProgress',
    'vipDisplayXp',
    'vipNextXp'
  ]),

  // 🔹 Sonra formatlı değer
  formattedVipXp() {
    if (!this.vipDisplayXp || isNaN(this.vipDisplayXp)) return '0.00';
    return Number(this.vipDisplayXp).toFixed(2);
  },

  activeWallet() {
    const user = this.authUser.user;
    if (!user || !user.currency) return { balance: 0 };

    const { coinType, type, chain } = user.currency;
    return (
      user.wallets.find(
        w =>
          w.coinType === coinType &&
          w.type === type &&
          w.chain === chain
      ) || { balance: 0 }
    );
  },

  activeWalletIcon() {
    if (!this.activeWallet.coinType) return require('@/assets/img/rivocoin.png');
    return require(`@/assets/img/coins/${this.activeWallet.coinType}.svg`);
  },

  vipBadgeImage() {
    return this.vipLevel?.vipBadgeImage
      ? process.env.VUE_APP_BACKEND_URL + this.vipLevel.vipBadgeImage
      : null;
  }
},


  watch: {
    // Eğer Vuex'teki sidebar durumu mobilde otomatik açılmaya neden oluyorsa,
    // bu watch ile Vuex durumunu gözlemleyip kontrol edebiliriz
    isSidebarClosed(newVal) {
      if (this.isMobile) {
        this.isSidebarOpen = !newVal;
      }
    }
  },
  mounted() {
     this.selectedFiat = this.authUser.user?.currency?.fiatCurrency || 'USD';
  this.checkIfMobile(); 
  window.addEventListener('resize', this.checkIfMobile); 

  if (this.isMobile) {
    // Mobilde sidebar'ı kapalı olarak başlatıyoruz
    this.$store.commit('toggleSidebar', true); 
  }
},
  methods: {
     showSidebarTooltip(text, event) {
    if (!this.isSidebarClosed) return;

    const rect = event.currentTarget.getBoundingClientRect();
    this.tooltip.text = text;
    this.tooltip.top = rect.top + rect.height / 2;
    this.tooltip.left = rect.right + 10; // sağa 10px boşluk
    this.tooltip.visible = true;
  },
  hideSidebarTooltip() {
    this.tooltip.visible = false;
  },
    openLanguage() {
  this.showLanguageModal = true;
},
 openDailyBonus() {
    this.dailyModal = true;
 },
 openSpinModal() {
  this.spinModal = true;
},
    getCurrencySymbol(code) {
      const symbols = {
        USD: '$',
        EUR: '€',
        TRY: '₺',
        BRL: 'R$',
        CNY: '¥',
        INR: '₹',
        IDR: 'Rp',
        RUB: '₽'
      };
      return symbols[code] || code;
    },
    setActiveMode(mode) {
      this.activeMode = mode;
    },
    
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      document.body.classList.toggle('dark-mode', this.isDarkMode);
    },
   
    
    ...mapActions(['toggleSidebar', 'toggleSidebarMobile', 'modalsSetShow']),
    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768; // 768px altındaki ekranlar mobil sayılır
      if (this.isMobile) {
        this.isSidebarOpen = false; // Mobilde sidebar varsayılan olarak kapalı
      }
    },
    
    

    toggleCategory(categoryName) {
      this.activeCategory = this.activeCategory === categoryName ? '' : categoryName;
    },
  getSubCategories(categoryName) {
    const category = this.categories.find(cat => cat.name === categoryName);
    return category ? category.subCategories : [];
  },
  navigateTo(route) {
  if (this.$route.fullPath === route) {
    // Aynı route ise zorla yeniden yükle
    this.$router.replace({ path: '/_refresh' }).then(() => {
      this.$router.replace(route);
    });
  } else {
    this.$router.push(route);
  }

  // Mobilde tıklayınca sidebar kapansın (opsiyonel ama önerilir)
  if (this.isMobile) {
    this.isSidebarOpen = false;
    this.toggleSidebarMobile();
  }
},
    toggleMobileSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen; // Mobilde sidebar'ı açıp kapatır
      this.toggleSidebarMobile(); // Vuex'teki durumu da günceller
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIfMobile);
  },
  
};
</script>

<style scoped>
.sidebar {
  background: var(--sidebar-bg);
  position: fixed;
  top: 61px;
  bottom: 0px;
  left: 0px;
  width: 16.375rem;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: calc(100vh - 61px);
  z-index: 9;
  outline: rgba(255, 255, 255, 0.06) solid 1px;
  transition: transform 0.3s ease;
  height: 100vh;
  position: relative; /* pseudo-element için */
}

/* Sağ üstten dışa doğru kavis */
.sidebar::before {
  content: "";
  position: absolute;
  top: 0;
  right: -60px;          /* dışarı taşı */
  width: 60px;
  height: 60px;
  background: var(--sidebar-bg);
  border-top-left-radius: 60px;  /* sağa doğru dış kavis */
}


.sidebar-closed {
  width: 4.5rem;
  overflow: hidden;
}

.sidebar-buttons {
  list-style: none;
  padding: 0;
}




.sidebar-tooltip {
  position: fixed;
  transform: translateY(-50%);
  background: var(--background2); /* balon rengi */
  color: #fff;      /* yazı rengi */
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  white-space: nowrap;
  z-index: 9999;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
}

 


/* Açılır Menü İkonu */
.dropdown-icon {
  font-size: 14px;
  color: white;
  transition: transform 0.3s ease;
  
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.5rem;
  
  /* ✅ FLEXBOX ile tam ortalama */
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Açık Durumda Dropdown Simgesi Döner */
.dropdown-icon.open {
  transform: rotate(180deg);
}

/* Alt Menü */
.sub-menu {
  
  padding: 5px;
  margin-bottom: 5px;
  list-style: none;
  background: #94a6cd26;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
  transition: 0.3s;
  margin-top: -1px;

  position: relative; /* ::before için gerekli */
  
}
 


/* Alt Menü Öğeleri */
.sub-item {
  display: flex;
  align-items: center;
  padding: 7px;
  color: white;
  transition: 0.3s;
  cursor: pointer;
  height: 40px;

}
.sub-menu + .button-item {
  margin-top: 10px;
}
.sub-menu + .button-item {
  margin-top: 10px;
}

.sub-item:hover {
  background: var(--hover);
  border-radius: 8px;
}

/* Alt Menü İkonları */
.sub-item-icon {
  width: 20px;
  height: 20px;
}

/* Alt Menü Metni */
.sub-item-text {
  padding-left: 8px;
  font-family: var(--font-header);
  font-size: 12px;
    font-variant-numeric: lining-nums tabular-nums;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 18px;
    margin-bottom: 0;
    margin-top: 0;
  color: white;
  flex-grow: 1;
}

.extra-buttons {
  position: relative;
  border-radius: 5px;
  margin: 10px;
  background: var(--background2);
  z-index: 1;
   

  /* overflow: hidden kaldırılıyor */
  /* overflow: visible olarak bırakılıyor */
}





/* Extra Butonlar */
.extra-buttons .button-item {
  position: relative;     /* ✅ gerekli */
  overflow: hidden;       /* ✅ before efektinin taşmaması için */
  z-index: 1;    
  border-radius: 6px;
  margin-bottom: 5px;
  background: none;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.extra-buttons .button-item:hover {
  background: var(--hover);
}

/* Extra Buton İkonları */
.extra-buttons .button-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

/* Animasyon Efektleri */
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s ease-in;
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-5px);
  opacity: 0;
}
@media (max-width: 768px) {
  .sidebar {
     
    z-index: 9;
    height: calc(100vh - 121px);
  }

  .sidebar-closed {
    transform: translateX(-100%); /* Kapalıyken görünmez */
  }

  .sidebar-open {
    transform: translateX(0); /* Açıldığında görünür yap */
  }
}

.sidebar-user-info {
  display: flex;
  align-items: center;
  padding: 10px;
  padding-bottom: 0;
  
  /* 🔹 Background resmi */
  background: url('@/assets/img/sidebar/user-bg.png') no-repeat center center;
  background-size: cover; /* Resmi alanın içine orantılı sığdır */
 
}


.user-avatar {
  width: 81px;
  height: 81px;
  border-radius: 7px;
  margin-right: 10px;
  object-fit: cover;
}

.user-info-text {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.username {
  color: white;
  font-weight: bold;
  display: flex;
  align-items: center;
  font-size: 13px;
}

.vip-badge {
  width: 20px;
  height: 20px;
  margin-left: 6px;
}

.username img {
  
  width: 30px;
  height: 30px;
  margin-left: 6px;

}

.balance-box {
  background: var(--background2);
  padding: 4px 8px;
  border-radius: 5px;
  color: #01e0a3;
  font-size: 13px;
  margin-top: 6px;
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
}

.balance-box .wallet-icon {
  width: 20px;
  height: 20px;
}

.vip-progress {
 margin-top: 20px;
}

.vip-progress-bar {
  width: 100%;
  height: 6px;
  background: var(--bar-outer) ;
  border-radius: 3px;
  overflow: hidden;
}

.vip-progress-fill {
  height: 100%;
  background: var(--bar-inner);
  transition: width 0.3s ease-in-out;
}

.vip-progress-text {
  font-size: 10px;
  color: #ccc;
  margin-top: 2px;
  text-align: right;
}


/* İmg butonlar sabit üstte olacak */
.img-button {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;

  padding: 5px 0;
}

.img-button img {
  width: 56px;
  height: 56px;
}

/* Yatay kaydırma çubuğu görünümünü gizleyebilirsin */
.mobile-horizontal .sidebar-buttons::-webkit-scrollbar {
  display: none; /* Kaydırma çubuğunu gizle */
}





.sidebar-buttons {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  padding-right: 10px;
  
}
.sidebar-closed .sidebar-buttons {
  display: block; /* Tek sütun haline gelir */
  padding: 0  1rem;
}

/* Sidebar kapalı olduğunda butonların boyutları küçülür */
.sidebar-closed .button-item {
  width: 100%; /* Tam genişlikte olur */
 
}

.sidebar-top-images, .sidebar-bottom-images {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding-top: 7px;
    padding-left: 15px;
    padding-right: 15px;
}

/* Sidebar KAPALIYKEN butonları dikey hizala */
.sidebar-closed .sidebar-top-images,
.sidebar-closed .sidebar-bottom-images {
  flex-direction: column;
  align-items: center;
  gap: 5px; /* Daha kompakt görünmesi için */
  display: none;
}





/* Sidebar AÇIKKEN img'ler normal boyut */
.sidebar-top-images img, .sidebar-bottom-images img {
  width: 120px;
  height: auto;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

/* Sidebar KAPALIYKEN img'leri küçült ve alt alta diz */
.sidebar-closed .sidebar-top-images img,
.sidebar-closed .coin-card,
.sidebar-closed .sidebar-footer,
.sidebar-closed .sidebar-bottom-images img {
  display: none;
}

.sidebar-closed .sidebar-user-info{
  display: none;
}

.button-item {
  margin: 3px 0;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--background2);
  color: white;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.3s;
  height: 40px;

  position: relative;
  z-index: 1;
  overflow: hidden;
}

.button-item.open {
  border-radius: 6px 6px 0 0;
  color: #01e0a3;
}



.button-item:hover {
  background: var(--hover);
}


.button-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
 
  transition: filter 0.3s ease;
}



.button-text {
  font-family: "Rubik", sans-serif;
  font-size: 14px;
    font-variant-numeric: lining-nums tabular-nums;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 18px;
    margin-bottom: 0;
    margin-top: 0;
  color: var(--text-color);
  flex-grow: 1;
}



.sidebar-closed .img-button img {
  width: 56px;
  height: 56px;
  transform: translateX(0); /* Taşmayı önlemek için */
}

  
.sidebar-closed .button-text {
  opacity: 0; /* Sidebar kapandığında yazılar gizlenir */
}
/* Her ikon için özel shadow ayarları */

.img-button {
  cursor: pointer;
}

.mode-switch {
  display: flex;
  gap: 10px;
    justify-content: space-between;
    padding: 10px;
    background: var(--card2-bg);
    border-radius: 8px;
    margin: 5px;
    margin-top: 10px;
}







.mode-label {
  font-family: var(--font-header);
  font-size: 14px;
    font-variant-numeric: lining-nums tabular-nums;
    font-weight: 600;
    color: white;
}


.sidebar-closed .button-item {
  width: 2.5rem; /* Daha dar bir genişlik */
  padding: 10px; /* Buton içindeki boşluğu azalt */
  justify-content: center; /* İkonları ortala */
}

.sidebar-closed .button-item .button-text {
  display: none; /* Sidebar kapalıyken yazıları gizle */
}
.sidebar-closed .button-item .button-icon {
  margin-right: 0; /* İkonları ortala */
}

.sidebar-closed .dropdown-icon {
  display: none;
}

/* Sidebar kapalıyken tüm butonları 2.5rem genişliğe sabitle */
.sidebar-closed .button-item,
.sidebar-closed .switch-button,
.sidebar-closed .extra-buttons .button-item {
  width: 2.5rem;
  padding: 8px;
  justify-content: center;
}

/* Sidebar kapalıyken butonların içindeki metinleri gizle */
.sidebar-closed .button-text,
.sidebar-closed .switch-button span,
.sidebar-closed .extra-buttons .button-text {
  display: none;
}

/* Sidebar kapalıyken switch butonları içeriği ortalayacak */
.sidebar-closed .switch-button {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Sidebar kapalıyken iconların hizalaması */
.sidebar-closed .button-icon,
.sidebar-closed .switch-button img,
.sidebar-closed .extra-buttons .button-icon {
  margin-right: 0;
}

/* Extra Butonlar için aynı genişlik */
.sidebar-closed .extra-buttons {
  width: 2.5rem;
  margin-left: 15px;
}

 
.coin-card {
  position: relative;
      padding: 12px;
  background: transparent;
}

.button-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  width: 100%;
  height: 100%;
  gap: 8px;
}

.grid-item {
  position: relative;         /* yazı için referans */
  cursor: pointer;
  overflow: hidden;
}

.grid-item img {
  width: 100%;
  height: 100%;
  display: block;
}

.grid-item span {
  position: absolute;
  top: 6px;   /* üstten biraz boşluk */
  font-size: 12px;
  font-weight: 700;
  color: white;
  text-shadow: 0px 2px 4px rgba(0,0,0,0.6);
  pointer-events: none;
  white-space: nowrap; /* taşmasın */
}

/* Sol sütun (1 ve 3): yazılar sağ üstte */
.button-grid .grid-item:nth-child(1) span,
.button-grid .grid-item:nth-child(3) span {
  right: 20px;
  text-align: right;
}

/* Sağ sütun (2 ve 4): yazılar sol üstte */
.button-grid .grid-item:nth-child(2) span,
.button-grid .grid-item:nth-child(4) span {
  left: 20px;
  text-align: left;
}
/* Coin ortada */
.coin-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.coin-center img {
  width: 45px;
  height: 45px;
  margin-top: 5px;
   animation: flip 5s linear infinite;
   transform-style: preserve-3d; /* 3D dönüş için */
}

@keyframes flip {
  from {
    transform: rotateY(0deg);
  }
  to {
    transform: rotateY(360deg);
  }
}


.sidebar-scrollable {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 120px; /* footer alanına yer bırak */
}

/* Sabit footer */
.sidebar-footer {
  position: sticky;
  bottom: 0;
  background: var(--sidebar-bg);
  padding: 10px;
  border-top: 1px solid rgba(255,255,255,0.08);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-buttons {
  display: flex;
  width: 100%;
  gap: 5px;
}

.footer-btn {
  flex: 1;
  background: var(--background2);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px;
  cursor: pointer;
  transition: background 0.3s;
   
}

/* Sol buton */
.footer-buttons .footer-btn:first-child {
  border-right: none; /* ortadaki çizgiye bırakıyoruz */
  border-radius: 8px 0 0 8px;
}

/* Sağ buton */
.footer-buttons .footer-btn:last-child {
  border-left: none; /* ortadaki çizgiye bırakıyoruz */
  border-radius: 0 8px 8px 0;
}

 

.footer-btn img {
  width: 20px;
  height: 20px;
}

.footer-btn span {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
}

.footer-banner {
  position: relative; /* pseudo-element için gerekli */
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--background1);
  border-radius: 8px;
  min-height: 96px;
  height: 96px;
  overflow: hidden; /* efekt taşmasın */
}

/* Sağ alttan ışık efekti */
.footer-banner::after {
  content: "";
  position: absolute;
  right: -30px;   /* sağ dıştan gelsin */
  bottom: -30px;  /* alttan gelsin */
  width: 120px;
  height: 120px;
  background: radial-gradient(circle at bottom right, rgb(123 108 185 / 96%) 0%, rgb(123 108 185 / 63%) 40%, transparent 80%);
  pointer-events: none; /* tıklamaları engellemesin */
  z-index: 1;
}


.footer-banner .banner-text {
  flex: 1;
  padding: 10px;
}

.footer-banner .banner-text h4 {
  font-size: 13px;         /* küçültüldü */
  font-weight: 700;
  color: #fff;
  margin: 0 0 2px;
  
}

.footer-banner .banner-text p {
  font-size: 11px;         /* küçültüldü */
  color: var(--text-color);
  margin: 0;
  font-weight: bold;
}

/* Sağdaki resim */
.footer-banner .banner-img {
  width: 100px;
  height: 100%;             /* kutunun yüksekliğini takip etsin */
  overflow: hidden;         /* fazla kısımları kırp */
  border-radius: 6px;
  display: flex;
  align-items: flex-start;  /* resmi üstten başlat */
  justify-content: center;
  padding-top: 10px;
  padding-right: 10px;
}

/* Resmin kendisi */
.footer-banner .banner-img img {
  width: 100%;
  height: auto;
  object-fit: cover;        /* taşarsa düzgün kırpsın */
   
}

.download-btn {
  margin-top: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background: var(--buttonyellow);
  border: none;
  border-radius: 6px;
  cursor: pointer;
      text-shadow: 0px 0px 4px #C56A18;
  transition: transform 0.2s ease, background 0.3s ease;
      box-shadow: rgb(197, 106, 24) 0px -3px 0px 0px inset, rgb(255, 234, 47) 0px 2px 0px 0px inset;
}


.sidebar-closed .sub-menu,
.sidebar-closed .sub-item {
  pointer-events: auto !important;
}
</style>
